<template>
  <div id="app">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
    />
    <component :is="isMobile ? 'MobileNav' : 'NavBar'" />
    <router-view class="view-content" />
    <footer id="footer">
      <b-container fluid id="content-container">
        <b-row no-gutters align-h="between" id="footer-main-row">
          <b-col class="footer-col-left">
            <p 
            @click="scrollToContactUs" 
            id="text-contact-us" 
            class="footer-header"
            >
              Contact Us
            </p>
            <a href="mailto: support@gethandoff.app">
              <p id="email-text" class="footer-body">support@gethandoff.app</p>
            </a>
          </b-col>
          <b-col class="footer-col-right" id="terms-column">
            <small class="footer-body"
              >&copy; Copyright 2023, Handoff Technologies LLC</small
            >
          </b-col>
          <b-col>
            <router-link
              class="footer-nav-item"
              to="/terms-conditions"
              @click.native="closeMenu"
              >Terms And Conditions</router-link
            >
            <router-link
              class="footer-nav-item"
              to="/privacy-policy"
              @click.native="closeMenu"
              >Privacy Policy</router-link
            >
            <router-link
              class="footer-nav-item"
              to="/customer-agreement"
              @click.native="closeMenu"
              >Customer Agreement</router-link
            >
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>

<script>
import NavBar from '../src/components/infastructure/NavBar';
import MobileNav from '../src/components/infastructure/MobileNav.vue';
import { EventBus } from './tools/event-bus'
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data: function() {
    return {
      isMobile: false
    };
  },
  components: {
    NavBar,
    MobileNav
  },
  computed: {
    ...mapGetters('user', {
      name: 'userProfile'
    }),
    currentRoute() {
      return this.$route.name;
    }
  },

  mounted() {
    this.isMobile = this.isMobileDevice();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    companyClick() {},
    ...mapActions('user', {
      login: 'login',
      logout: 'logout'
    }),
    handleResize() {
      this.isMobile = this.isMobileDevice();
    },
    isMobileDevice() {
      const mobileBreakpoint = 768;
      return window.innerWidth < mobileBreakpoint;
    },
    scrollToContactUs() {
      this.goToRoute('/support')
      EventBus.$emit('scroll-to-contact')
    },
    goToRoute(path) {
      if (this.$route.path !== path) this.$router.push(path);
    }
  }
};
</script>

<style>

#app {
  font-family: Calibri, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
  padding-bottom: 69px;
}
.footer-body {
  font-size: 12px;
  color: rgb(255, 255, 255);
}
.footer-header {
  font-size: 13px;
  color: rgb(255, 255, 255);
  margin-top: 2%;
}

.view-content {
  padding-bottom: 69px;
}
#text-contact-us {
  text-decoration: underline;
  margin-bottom: 0;
  cursor: pointer;
}
#terms-column {
  text-align: center;
  align-self: center;
}
#email-text {
  cursor: pointer;
  color: #ffffff;
}
#smaller-ling {
  font-size: 10px !important;
}
#modal-body {
  text-align: center;
}
#app {
  font-family: Calibri, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
#content-container {
  max-height: -webkit-fill-available;
}
#footer {
  background-color: rgb(11, 173, 135);
  text-align: left;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 69px;
}

.footer-nav-item {
  font-size: 12px;
  display: flex;
  color: white !important;
  justify-content: end;
}

.footer-nav-item:hover {
  color: white !important;
}
</style>
